export default __webpack_public_path__ + "static/media/IMG7.844ba763.jpg";